/**
 * @flow
 * @relayHash 692e8552f028ab20e02412aaf0753915
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateContractLineItemInput = {
  clientMutationId?: ?string,
  contract_id: string,
  title: string,
  quantity: number,
  price_cents: number,
  price_currency: string,
  description?: ?string,
  add_to_library?: ?boolean,
};
export type Library_Contract_createContractLineItemMutationVariables = {|
  input: CreateContractLineItemInput
|};
export type Library_Contract_createContractLineItemMutationResponse = {|
  +createContractLineItem: ?{|
    +new_contract_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
    +new_user_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
  |}
|};
export type Library_Contract_createContractLineItemMutation = {|
  variables: Library_Contract_createContractLineItemMutationVariables,
  response: Library_Contract_createContractLineItemMutationResponse,
|};
*/


/*
mutation Library_Contract_createContractLineItemMutation(
  $input: CreateContractLineItemInput!
) {
  createContractLineItem(input: $input) {
    new_contract_line_item_edge {
      node {
        id
        title
        description
        position
        price_cents
        price_currency
        quantity
      }
    }
    new_user_line_item_edge {
      node {
        id
        title
        description
        price_cents
        price_currency
        quantity
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractLineItemInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price_cents",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price_currency",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractLineItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateContractLineItemInput!"
      }
    ],
    "concreteType": "CreateContractLineItemPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "new_contract_line_item_edge",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractLineItemEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractLineItem",
            "plural": false,
            "selections": [
              v1,
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "position",
                "args": null,
                "storageKey": null
              },
              v4,
              v5,
              v6
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "new_user_line_item_edge",
        "storageKey": null,
        "args": null,
        "concreteType": "UserLineItemEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserLineItem",
            "plural": false,
            "selections": [
              v1,
              v2,
              v3,
              v4,
              v5,
              v6
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Library_Contract_createContractLineItemMutation",
  "id": null,
  "text": "mutation Library_Contract_createContractLineItemMutation(\n  $input: CreateContractLineItemInput!\n) {\n  createContractLineItem(input: $input) {\n    new_contract_line_item_edge {\n      node {\n        id\n        title\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n    new_user_line_item_edge {\n      node {\n        id\n        title\n        description\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Library_Contract_createContractLineItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v7
  },
  "operation": {
    "kind": "Operation",
    "name": "Library_Contract_createContractLineItemMutation",
    "argumentDefinitions": v0,
    "selections": v7
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5de9cb68b1c3f9011c768f6d005ef09e';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/Library_Contract_createContractLineItemMutation.graphql.js